module.exports = __webpack_public_path__ + "img/material-card2-m.a5a3d97f.png";